module.exports = __webpack_public_path__ + "img/cute_handdrawn_4.e5f92a34.png";